import axios, { AxiosResponse } from "axios";
import { API_URL_AUTH } from '../constants/index';
import { IRegisterRequest, ILoginRequest, IForgotPasswordRequest, IForgotPasswordUserRequest, IResetPasswordRequest, IResetPasswordUserRequest, ILoginResponse, CurrentUserResponse } from "../interfaces/types";
import authHeader from "./auth-header";

type ApiResponse<T = any> = Promise<AxiosResponse<T>>;

const register = (username: string, email: string, password: string): ApiResponse => {
  const requestBody: IRegisterRequest = { username, email, password };
  return axios.post(API_URL_AUTH + "/signup", requestBody);
};

const login = (username: string, password: string): ApiResponse<ILoginResponse> => {
  const requestBody: ILoginRequest = { username, password };
  return axios
    .post(API_URL_AUTH + "/signin", requestBody)
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.removeItem("user");
        localStorage.setItem("accessToken", response.data.accessToken);
        localStorage.setItem("tokenType", response.data.tokenType || "Bearer");
      }

      return response;
    });
};

const getCurrentUser = (): ApiResponse<CurrentUserResponse> => {
  return axios.get(API_URL_AUTH + "/me", {
    headers: authHeader(),
  });
};

const forgotPassword = (username: string): ApiResponse => {
  const requestBody: IForgotPasswordRequest = { username };
  return axios.post(API_URL_AUTH + "/forgot-password", requestBody);
};

const forgotPasswordUser = (username: string): ApiResponse => {
  const requestBody: IForgotPasswordUserRequest = { username };
  return axios.post(API_URL_AUTH + "/forgot-password-user", requestBody);
};

const resetPassword = (token: string, email: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordRequest = { token, email, password };
  return axios.post(API_URL_AUTH + "/reset-password", requestBody);
};

const resetPasswordUser = (token: string, username: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordUserRequest = { token, username, password };
  return axios.post(API_URL_AUTH + "/reset-password-user", requestBody);
};

const resetClientPassword = (token: string, username: string, password: string): ApiResponse => {
  const requestBody: IResetPasswordUserRequest = { token, username, password };
  return axios.post(API_URL_AUTH + "/reset-client-password", requestBody);
};

const getResetPassword = (token: string): ApiResponse => {
  return axios.get(API_URL_AUTH + "/reset-password/" + token);
};

const logout = (): void => {
  localStorage.removeItem("user");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("tokenType");
};

const authService = {
  register,
  login,
  getCurrentUser,
  logout,
  forgotPassword,
  forgotPasswordUser,
  resetPassword,
  resetPasswordUser,
  resetClientPassword,
  getResetPassword
};

export default authService;
